<template>
  <div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="70%"
      @close="setDialogClosed" append-to-body>
      <el-container v-loading="listLoading" direction="vertical" style="height: 500px;overflow: auto;">
        <el-row>
          <el-collapse v-model="activeNames">
            <el-collapse-item title="靶器官损害" name="1">
              <el-descriptions :column="3" border style="margin-bottom: 10px">
                <el-descriptions-item label="*蛋白尿">
                  <el-select v-model="detail.ALB" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="*肾脏损害[eGFR ml/(min · 1.73 m2 )]">
                  <el-input v-model="detail.eGFR" placeholder="请输入"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*左心室肥厚">
                  <el-select v-model="detail.leftVenHyper" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="*心房颤动">
                  <el-select v-model="detail.auricularFibrillation" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="*视网膜病变">
                  <el-select v-model="detail.retina" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>
              </el-descriptions>
            </el-collapse-item>

            <el-collapse-item title="心血管病危险因素" name="2">
              <el-descriptions :column="3" border style="margin-bottom: 10px">

                <el-descriptions-item label="*腰围(cm)">
                  <el-input v-model="detail.waist" placeholder="请输入"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*身高(cm)">
                  <el-input v-model="detail.height" placeholder="请输入"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*体重(kg)">
                  <el-input v-model="detail.weight" placeholder="请输入"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*心血管病既往史">
                  <el-select v-model="detail.cardio" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="*早发心血管病家族史(一级亲属发病年龄 <50 岁)、年龄(>40 岁)">
                  <el-select v-model="detail.cardioHistory" placeholder="请选择">
                    <el-option v-for="item in familyHistoryOptions" :key="item.value" :label="item.label"
                      :value="item.value" style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="*高血压">
                  <el-select v-model="detail.hyper" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="*吸烟">
                  <el-select v-model="detail.smoke" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="*代谢综合征">
                  <el-select v-model="detail.metasyn" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="*高尿酸血症">
                  <el-select v-model="detail.highUricAcidHis" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="评估结果">
                  <el-input disabled v-model="result" style="width: 200px"></el-input>
                </el-descriptions-item>
              </el-descriptions>
            </el-collapse-item>
          </el-collapse>
        </el-row>

        <el-row>
          <el-button type="primary" size="small" @click="submit()"
            style="margin-top: 10px; margin-left: 10px; width: 100px">提交评估</el-button>
          <el-button type="primary" size="small" @click="setDialogClosed()"
            style="margin-top: 10px; margin-left: 10px; width: 100px">关闭</el-button>
        </el-row>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import { addPatientEasyillAscvdDiabets } from "@/api/health/EhrQuery";
import { getLatestRiskFactors } from '@/api/health/RiskQuery';

export default {
  components: {},
  data() {
    return {
      showDialog: false,
      activeNames: ["1", "2"],
      title: "糖尿病患者心血管病风险评估",
      pInfo: null,
      pId: null,
      listLoading: false,
      detail: {
        patientId: null,
        patientName: null,
        healthNo: null,
        idcard: null,
        gender: null,
        age: null,
        waist: null,
        bmi: null,
        hyper: "否",
        cardio: "否",
        smoke: "否",
        cardioHistory: "无家族史",
        metasyn: "否",
        highUricAcidHis: "否",
        HCY: "否",
        ALB: "否",
        eGFR: null,
        leftVenHyper: "否",
        auricularFibrillation: "否",
        retina: "否"
      },
      familyHistoryOptions: [
        {
          value: "1",
          label: "有家族史",
        },
        {
          value: "2",
          label: "无家族史",
        },
      ],
      commonOptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      result: "--",
    };
  },
  methods: {
    // 编辑初始化页面内容
    async init(dataContext) {
      console.log(dataContext);
      this.showDialog = true;
      this.pInfo = dataContext;
      this.detail.patientId = dataContext.patientId;
      this.detail.patientName = dataContext.name;
      this.detail.healthNo = dataContext.healthNo;
      this.detail.idcard = dataContext.idcard;
      this.detail.gender = dataContext.gender;
      this.detail.age = this.getAge(dataContext.birthday);

      // const params = {
      //   patientId: this.detail.patientId,
      //   // dims: Object.getOwnPropertyNames(this.detail)
      //   dims: ["height", "weight", "waist", "BMI"]
      // }

      const params = {
        startTime:null,
        endTime:null,
        idcard: this.detail.idcard,
        paramNames: ["身高", "体重", "腰围", "BMI"]
      }

      this.listLoading = true;
      getLatestRiskFactors(params).then((res) => {
        this.listLoading = false;
        console.log("=======chushihua shuju========", res)
        if (res == []) {
          this.$message({
            message: "获取初始数据失败！",
            type: "warn"
          })
        }
        if (res.msg == "success") {
          this.$message({
            message: "获取初始数据成功！",
            type: "success"
          })
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    // 关闭对话框触发
    setDialogClosed() {
      this.detail = {
        patientId: null,
        patientName: null,
        healthNo: null,
        idcard: null,
        gender: null,
        age: null,
        waist: null,
        bmi: null,
        hyper: "否",
        cardio: "否",
        cardioHistory: "无家族史",
        metasyn: "否",
        highUricAcidHis: "否",
        smoke: "否",
        HCY: "否",
        ALB: "否",
        eGFR: null,
        leftVenHyper: "否",
        auricularFibrillation: "否",
        retina: "否"
      },
      this.$emit("update")
      this.showDialog = false;
    },
    submit() {
      if (!this.detail.ALB) {
        this.$message({
          message: "请选择是否蛋白尿！",
          type: "error"
        })
        return;
      }

      if (!this.detail.eGFR) {
        this.$message({
          message: "请输入肾脏损害！",
          type: "error"
        })
        return;
      }

      if (!this.detail.leftVenHyper) {
        this.$message({
          message: "请选择是否左心室肥厚！",
          type: "error"
        })
        return;
      }

      if (!this.detail.auricularFibrillation) {
        this.$message({
          message: "请选择是否心房颤动！",
          type: "error"
        })
        return;
      }

      if (!this.detail.retina) {
        this.$message({
          message: "请选择是否视网膜病变！",
          type: "error"
        })
        return;
      }


      if (!this.detail.waist) {
        this.$message({
          message: "请输入腰围！",
          type: "error"
        })
        return;
      }

      if (!this.detail.height) {
        this.$message({
          message: "请输入身高！",
          type: "error"
        })
        return;
      }
      if (!this.detail.weight) {
        this.$message({
          message: "请输入体重！",
          type: "error"
        })
        return;
      }
      if (!this.detail.cardio) {
        this.$message({
          message: "请选择是否心血管病既往史！",
          type: "error"
        })
        return;
      }
      if (!this.detail.cardioHistory) {
        this.$message({
          message: "请选择是否早发心血管病家族史！",
          type: "error"
        })
        return;
      }

      if (!this.detail.cardioHistory) {
        this.$message({
          message: "请选择是否早发心血管病家族史！",
          type: "error"
        })
        return;
      }

      if (!this.detail.hyper) {
        this.$message({
          message: "请选择是否高血压！",
          type: "error"
        })
        return;
      }

      if (!this.detail.smoke) {
        this.$message({
          message: "请选择是否吸烟！",
          type: "error"
        })
        return;
      }

      if (!this.detail.metasyn) {
        this.$message({
          message: "请选择是否代谢综合征！",
          type: "error"
        })
        return;
      }


      if (!this.detail.highUricAcidHis) {
        this.$message({
          message: "请选择是否高尿酸血症！",
          type: "error"
        })
        return;
      }


      this.detail.bmi = Number(this.detail.weight / Math.pow(this.detail.height / 100, 2)).toFixed(2);
      addPatientEasyillAscvdDiabets(this.detail).then((res) => {
        console.log(res);
        if (res.msg == "success") {
          if (res.data) {
            this.result = res.data.riskName;
            this.$message({
              message: "查询结果成功！",
              type: "success",
            });
          } else {
            this.$message({
              message: "查询结果失败！",
              type: "warn",
            });
          }
        }
      }).catch((error) => {
        conslse.log(error);
      });
    },
    // 计算当前年龄
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }

  .el-descriptions-item__label.is-bordered-label {
    width: 140px;
  }

  .el-checkbox-group {
    width: 100px;
  }
}
</style>